var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 16.933 16.933",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.35.529c-.635 0-1.17.46-1.296 1.058h-.82a.798.798 0 0 0-.794.794v1.058c0 .435.358.794.793.794h4.234a.798.798 0 0 0 .793-.794V2.381a.798.798 0 0 0-.793-.794h-.821A1.337 1.337 0 0 0 6.35.53zM1.323 2.117a.798.798 0 0 0-.794.793V15.61a.8.8 0 0 0 .794.795h10.054a.8.8 0 0 0 .794-.795v-1.025c-.335.12-.69.194-1.059.219v.277a.265.265 0 0 1-.265.265H1.85a.265.265 0 0 1-.264-.265V3.44a.265.265 0 0 1 .264-.266h1.06V2.38c0-.09.01-.178.027-.264zm8.44 0c.017.086.027.174.027.264v.793h1.057a.265.265 0 0 1 .266.265v3.453c.369.025.723.1 1.058.22V2.91a.798.798 0 0 0-.794-.793zM2.91 5.291a.265.265 0 0 0-.265.265V8.73a.265.265 0 0 0 .265.266h2.645a.265.265 0 0 0 .265-.266V5.556a.265.265 0 0 0-.265-.265zm3.704 0c-.353 0-.353.529 0 .529H9.79c.353 0 .353-.53 0-.53zm-.013 1.588c-.366.017-.34.546.013.529h1.851c.353 0 .353-.53 0-.53zm4.247.529a3.444 3.444 0 0 0-3.44 3.44 3.444 3.444 0 0 0 3.44 3.44 3.443 3.443 0 0 0 3.439-3.44 3.443 3.443 0 0 0-3.439-3.44zM6.602 8.467c-.366.017-.34.546.013.529h.265c.353 0 .353-.53 0-.53zm4.247 0a2.384 2.384 0 0 1 2.38 2.38 2.384 2.384 0 0 1-2.38 2.381 2.387 2.387 0 0 1-2.383-2.38 2.387 2.387 0 0 1 2.383-2.381zm-7.952 1.588c-.365.019-.338.546.014.529h3.174c.353 0 .353-.53 0-.53zm.014 1.585c-.352 0-.352.53 0 .53h3.44c.352 0 .352-.53 0-.53zm0 1.588c-.352 0-.352.53 0 .53h1.057c.353 0 .353-.53 0-.53zm2.116 0c-.353 0-.353.53 0 .53h2.117c.353 0 .353-.53 0-.53zm9.256 0a.265.265 0 0 0-.183.078l-.794.794a.265.265 0 0 0 0 .374l1.69 1.689a.83.83 0 0 0 1.168 0 .829.829 0 0 0 0-1.167l-1.69-1.69a.265.265 0 0 0-.19-.077z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestigation);
export default __webpack_public_path__ + "static/media/investigation.8e6b06e8ee5b0200f960d2ba94865279.svg";
export { ForwardRef as ReactComponent };